// import { createClient } from "@sanity/client";

// export const client = createClient({
//    projectId: "pcafmc1n", 
//    dataset: "production", 
//    apiVersion: "2024-03-11",
//    // Set to `true` for production environments
//    useCdn: true, 
// })

import { createClient } from "@sanity/client";

export default createClient({
  projectId: "pcafmc1n",
  dataset: "production",
  useCdn: true,
  apiVersion: "2022-03-08"
})